<template>
  <div class="container">
    <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="item in list" :key="item" :title="item" />
      </van-list> -->
    <div v-for="item in $store.getters.followInfoList">
      <div class="content-info" @click="checkInfo(item)">
        <div class="content-head">
          <img :src="item.avatarLink || defaultPhoto"
            style="width: 100%;height: 100%;object-fit: cover;object-position: center;" />
        </div>
        <div class="content-detail">
          <span class="detail-line1">{{ item.nickName || formatSerial(item.serialNumber) }}</span>
          <div class="detail-line2">
            <span>
              <span>性别:</span>
              <span>{{ item.sex === 1 ? '男' : '女' }}</span>
            </span>
            <span>
              <span>年纪:</span>
              <span>{{ item.birthday && getUpdateTime(item.birthday) }}</span>
            </span>
            <span>
              <span>身高:</span>
              <span>{{ item.height }}CM</span>
            </span>
          </div>
          <div class="detail-line3">
            <span>
              <span>籍贯:</span>
              <span>{{ item.hometown }}</span>
            </span>
          </div>
          <div class="detail-line4" v-if="item.theOtherHalfName">
            <span class="relation-label">推荐对象</span>
            <span class="relation-name">{{ item.theOtherHalfName }}</span>
            <span class="relation-serial">#{{ item.theOtherHalfSerialNumber }}</span>
          </div>
        </div>
        <div class="content-go"></div>
      </div>
    </div>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import { getFollowUpMembers } from '../../api/user';
export default {
  name: 'MemberFollow',
  // props: {
  //   infoList: Array,
  // },
  data() {
    return {
      showPicker: false,
      value: '',
      page: this.$store.getters.followPage.page,
      pageSize: 10,
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华'],
      list: [],
      loading: false,
      finished: false,
      queryVisible: true,
      educationData: [
        '大专', '本科', '硕士', '博士', '高中及以下'
      ],
    };
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = true;
    },
    click() {
      this.queryVisible = false;
    },
    checkInfo(item) {
      // 跳转下个页面记录当前节点， 其实这里不用也没关系
      this.$store.dispatch('SetQueryName', 'follow');
      this.$router.push({ path: `/detailInformation/${item.id}`, });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    getUpdateTime(time) {
      let birthYear = Number(time.slice(0, 4));
      let Y = new Date().getFullYear();
      return Y - birthYear;
    },
    getMoreInfo() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollHeight - clientHeight <= scrollTop + 3) {
        if (!this.loading && !this.finished && this.$store.getters.followInfoList.length >= this.page * this.pageSize) {
          this.loading = true;
          this.page++;
          this.$store.dispatch('SET_Page', { name: 'followPage', page: this.page });
          const params = {
            matchmakerInfoId: this.$store.getters.baseInfo.id,
            page: this.page,
            pageSize: this.pageSize,
          }
          getFollowUpMembers(params).then(res => {
            if (res) {
              const followInfoList = this.$store.getters.followInfoList.concat(res.data.items);
              this.loading = false;
              this.finished = followInfoList.length >= res.data.total;
              this.$store.dispatch('SetFollowInfoList', followInfoList);
            }
          }).catch(() => {
            this.loading = false;
          });
        }
      }
    },
    formatSerial(serialNumber) {
      if (!serialNumber) return "0000";
      return String(serialNumber).padStart(4, "0");
    },
  },
  created() {
  },
  computed: {
    ...mapGetters([
      'baseInfo'
    ]),
  },
  mounted() {
    window.addEventListener('scroll', this.getMoreInfo, false);
  },
  destroyed() {
    window.removeEventListener('scroll', this.getMoreInfo);
  }
};
</script>
<style scoped lang="less">
@import url('../../style/theme-variables.less');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  padding: 0.95rem 0.8rem 0;
}

.content-info {
  width: 100%;
  min-height: 5.2rem;
  margin-bottom: 0.8rem;
  padding: 0.85rem 0.9rem;
  background: @bg-card;
  border-radius: @radius-large;
  box-shadow: @shadow-card;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .content-head {
    width: 3.35rem;
    height: 3.35rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: @shadow-avatar;
  }

  .content-detail {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.32rem;

    .detail-line1 {
      font-size: 0.72rem;
      font-weight: @font-weight-semibold;
      color: @text-primary;
      line-height: 1rem;
    }

    .detail-line2,
    .detail-line3 {
      font-size: 0.58rem;
      color: @text-secondary;
      line-height: 0.86rem;
      display: flex;
      justify-content: space-between;
      gap: 0.4rem;
    }

    .detail-line3 {
      justify-content: flex-start;
    }

    .detail-line4 {
      display: flex;
      align-items: center;
      gap: 0.3rem;
      font-size: 0.52rem;
      line-height: 0.76rem;

      .relation-label {
        color: @text-tertiary;
      }

      .relation-name {
        color: @text-primary;
        font-weight: @font-weight-medium;
      }

      .relation-serial {
        display: inline-flex;
        align-items: center;
        min-height: 0.74rem;
        padding: 0.04rem 0.3rem;
        border-radius: 999px;
        background: rgba(255, 138, 154, 0.1);
        font-size: 0.46rem;
        color: @primary-color;
      }
    }
  }

  .content-go {
    width: 0.7rem;
    height: 0.7rem;
    flex-shrink: 0;
    background: url("../../assets/btn_arrow_black_6x6.png") no-repeat center;
    background-size: 0.42rem 0.42rem;
    opacity: 0.55;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matchmakerCenter/memberFollow.vue